import _ from 'lodash'
import * as api from '~/myApi'

export type Retio = {
  key?: string;
  num?: number;
}
export interface Retios {
  contact?: Retio
  cluster?: Retio
  device?: Retio
  carrer?: Retio
  os?: Retio
}

export const createTotalRatios = (targetRatio?: api.TypesTargetRatio) => {
  const tableItems: Retios[] = []

  const contactRatio = Object.entries(_.omit(targetRatio!.contactRatio!, 'isActive')).filter(([key, num]) => num)
  const clusterRatio = Object.entries(_.omit(targetRatio!.clusterRatio!, 'isActive')).filter(([key, num]) => num)
  const deviceRatio = Object.entries(_.omit(targetRatio!.deviceRatio!, 'isActive')).filter(([key, num]) => num)
  const carrerRatio = Object.entries(_.omit(targetRatio!.carrerRatio!, 'isActive')).filter(([key, num]) => num)
  const osRatio = Object.entries(_.omit(targetRatio!.osRatio!, 'isActive')).filter(([key, num]) => num)

  const c = contactRatio[0] ? contactRatio : [[]]
  c.forEach(([key, num]) => {
    const contactsRatios: Retios = {}
    if (num) {
      contactsRatios.contact = {
        key,
        num
      }
    }
    const cl = clusterRatio[0] ? clusterRatio : [[]]
    cl.forEach(([key, num]) => {
      const clusterRatios: Retios = Object.assign({}, contactsRatios)
      if (num) {
        clusterRatios.cluster = {
          key,
          num
        }
      }
      const d = deviceRatio[0] ? deviceRatio : [[]]
      d.forEach(([key, num]) => {
        const deviceRatios: Retios = Object.assign({}, clusterRatios)
        if (num) {
          deviceRatios.device = {
            key,
            num
          }
        }
        const car = carrerRatio[0] ? carrerRatio : [[]]
        car.forEach(([key, num]) => {
          const carrerRatios: Retios = Object.assign({}, deviceRatios)
          if (num) {
            carrerRatios.carrer = {
              key,
              num
            }
          }
          const o = osRatio[0] ? osRatio : [[]]
          o.forEach(([key, num]) => {
            const osRatios: Retios = Object.assign({}, carrerRatios)
            if (num) {
              osRatios.os = {
                key,
                num
              }
            }
            if (Object.entries(osRatios).length !== 0 && !tableItems.find(v => JSON.stringify(v) === JSON.stringify(osRatios))) {
              tableItems.push(osRatios)
            }
          })
        })
      })
    })
  })

  return tableItems
}

export default createTotalRatios